export const getFileName = (url: string): string | void => {
  const name = url.split("/").pop();

  if (!name) {
    return;
  }

  return name.replace(/#(.*?)$/, "").replace(/\?(.*?)$/, "");
};
